import { useContext } from 'react';
import { SocietesApi } from '@europrocurement/l2d-domain/openApi/ApiSociete';
import L2DApiContext from '../L2DApiContext';

export const useSocieteService = () => {
    const context = useContext(L2DApiContext);
    if (!context) {
        throw new Error('useL2DApi must be used within a L2DApiProvider');
    }

    if (!context.societe) {
        throw new Error('societe service is not registred in L2DApiProvider');
    }
    const { apis } = context.societe;

    return {
        societeApi: apis.societeApi as SocietesApi,
    };
};
